export default "__VITE_ASSET__Co0Z8ZUU__"